import React, { useContext, useState } from "react";
import { Button, Dropdown, Icon, Menu, Tooltip } from "antd";
import style from "./index.module.scss";
import { CourseContext } from "../../../../Store";
import { Link, useHistory } from "react-router-dom";
import { BiUndo } from "react-icons/bi";
import useDeviceType from "Utils/useDeviceType";
import SectionPicker from "../SectionPicker";
import ChatModal from "components/WebIM/Components/ChatModal";
import useModalHandler from "Utils/useModalHandler";

interface CourseHeaderProps {
    contactList: {
        title: string;
        key: string;
        value: string;
        isMain: string;
    }[];
}

export default function CourseHeader({ contactList }: CourseHeaderProps) {
    const chatModal = useModalHandler();

    const history = useHistory();
    const { course, basename } = useContext(CourseContext);
    const { courseNo, courseSeq, weekTimeId, courseName } = course;
    const { isPC } = useDeviceType();
    const [selectedContact, setSelectedContact] = useState({
        no: "",
        name: ""
    });

    const onOpenChat = (select: string) => {
        const [no, name] = select.split("-");
        setSelectedContact({ no, name });
        chatModal.open();
    };

    const menu = (
        <Menu>
            {contactList.map(item => (
                <Menu.Item key={item.key} onClick={() => onOpenChat(item.key)}>
                    {item.title}
                    {item.isMain === "1" && contactList.length > 1 && (
                        <span className={style.majorflag}>主讲</span>
                    )}
                </Menu.Item>
            ))}
        </Menu>
    );

    return (
        <div className={style.root}>
            <div>
                <h1 className={style.title}>
                    <Tooltip title={course.courseName} placement="bottom">
                        <span className={style.courseTitle}>
                            {course.courseName}
                        </span>
                    </Tooltip>

                    {isPC && (
                        <Button
                            className={style.back}
                            onClick={() => history.goBack()}>
                            <BiUndo size={16} /> 返回
                        </Button>
                    )}
                </h1>
                <SectionPicker />
            </div>

            {isPC && (
                <div className={style.tools}>
                    {contactList.length === 1 && (
                        <span
                            className={style.btns}
                            onClick={() => onOpenChat(contactList[0].key)}>
                            <Icon type="message" className={style.scoreIcon} />
                            <p>私信</p>
                        </span>
                    )}

                    {contactList.length > 1 && (
                        <Dropdown overlay={menu}>
                            <span className={style.btns}>
                                <Icon
                                    type="message"
                                    className={style.scoreIcon}
                                />
                                <p>私信</p>
                            </span>
                        </Dropdown>
                    )}

                    <Link
                        className={style.btns}
                        title="课程章节"
                        to={`/course/chapters/${courseNo}/${courseSeq}/${weekTimeId}`}>
                        <Icon type="calendar" className={style.scoreIcon} />
                        <p>课程章节</p>
                    </Link>

                    <Link
                        className={style.btns}
                        title="成绩"
                        to={`/course/score/detail/${courseNo}/${courseSeq}/${weekTimeId}?courseName=${courseName}`}>
                        <img
                            className={style.scoreIcon}
                            src={require("./img/scoreIcon.png")}
                            alt=""
                        />
                        <p>成绩</p>
                    </Link>

                    <Link
                        className={style.btns}
                        title="学习报告"
                        to={`${basename}/report`}>
                        <Icon type="stock" className={style.scoreIcon} />
                        <p>学习报告</p>
                    </Link>
                </div>
            )}

            {isPC && (
                <ChatModal
                    courseNo={course.courseNo}
                    courseSeq={courseSeq}
                    visible={chatModal.visible}
                    onCancel={chatModal.close}
                    selectedContact={selectedContact}
                />
            )}
        </div>
    );
}
